// Copyright (c) 2016 Deere & Company

import Division, { getDefaultState } from '../state/division';
import actions from '../../../../sharedmodules/actions-list';

const updateDivisionParams = (state, action) => Division.update(state, {
    $set: action.division,
});

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_DIVISION_SUCCESS]: updateDivisionParams,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
